jQuery(function () {
    var $table = jQuery('#facilities');
    var city_filter = null;

    jQuery('body').on('click', '#search-city-link--battery', function (e) {
        var $city = jQuery('#search-city');
        var get = {};

        jQuery('#load-more--battery').show();
        jQuery('.table__column--no-results').remove();

        city_filter = $city.val();
        get.city = city_filter;
        jQuery('#search-postalcode').val('');

        get.offset = 0;

        jQuery.get('/api/wait_times', get, function (response) {
            var $html = jQuery(response);
            $table.children('tbody').remove();
            $table.append(response);

            if ($html.find('.table__column--no-results').length == 1) {
                jQuery('#load-more--battery').hide();
            }
        });

        return false;
    });


    jQuery('body').on('click', '#search-postal-link--battery', function (e) {
        var $postal = jQuery('#search-postalcode');
        var get = {};
        get.offset = 0;

        jQuery('#load-more--battery').show();
        jQuery('.table__column--no-results').remove();

        if ($postal.val()) {
            get.postal_code = $postal.val();
            jQuery('#search-city').val(jQuery('#search-city option:first').val());
        }

        jQuery.get('/api/wait_times', get, function (response) {
            $table.children('tbody').remove();
            $table.append(response);

            var $html = jQuery(response);
            if ($html.find('.table__column--no-results').length == 1) {
                jQuery('#load-more--battery').hide();
            }

        });


        return false;
    });


    // Load more data into table

    jQuery('body').on('click', '#load-more--battery', function (e) {

        //console.log('clicked!');

        var get = {};
        var records = $table.find('.table__row--clickable').length;
        get.offset = records;

        var $postal = jQuery('#search-postalcode');

        if (city_filter !== null)
            get.city = city_filter;

        if ($postal.val())
            get.postal = $postal.val();


        jQuery.get('/api/wait_times', get, function (response) {

            var $html = jQuery('<tbody>' + response + '</tbody>');

            $table.append(response);

            if ($html.find('.table__column--no-results').length == 1) {
                jQuery('#load-more--battery').hide();
            }
        });

        return false;
    });

});
